import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "listView",
  "use": "listView-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" id=\"listView\">\n<path d=\"M3 9.5H21V14.5H3V9.5ZM21 8V5.75C21 4.234 19.7665 3 18.25 3H5.75C4.2335 3 3 4.234 3 5.75V8H21ZM3 16V18.25C3 19.766 4.2335 21 5.75 21H18.25C19.7665 21 21 19.766 21 18.25V16H3Z\" fill=\"inherit\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol